import styled from "styled-components";

const Title = styled.h2`
  font-size: 20px;
  color: navy;
  text-align: center;
  width: 50vw;
  min-height: 50px;
  padding: 5px;
  margin: 10px auto;
  box-sizing: border-box;
  border-bottom: solid 1px black;
`;

export default Title;
